<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <WorkpackagesTemplate />
      </v-col>

      <v-col cols="12">
        <WorkpackagesArchived doc-path="160-templates" :entity="entities.template" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import i18n from '@/plugins/vue-i18n';
import { useDayjs } from '@/composables/use-dayjs';
import { useSnackbarStore } from '@/stores/snackbar';
import { useWorkpackageProductsStore } from '@/stores/workpackage-products';
import { useWorkpackagesStore } from '@/stores/workpackages';
import entities from '@enums/entities';
import { mapStores } from 'pinia';

export default {
  // components: {
  // },
  setup() {
    const { getUTCNow } = useDayjs();
    return { getUTCNow };
  },

  data() {
    return {
      entities,
      isArchiving: false,
    };
  },
  computed: { ...mapStores(useWorkpackagesStore, useSnackbarStore, useWorkpackageProductsStore) },
  created() {
    // TODO vuetify
    // this.workpackagesStore.fetchWorkpackages({ shouldGetTemplates: true, pickExtra: ['status'] });
    // this.workpackagesStore.fetchArchivedWorkpackages({
    //   limit: 5,
    //   offset: 0,
    //   filter: {},
    //   regexSearch: '',
    //   shouldGetTemplates: true,
    // });
  },
  methods: {
    async onArchiveWorkpackageClick(workpackageId) {
      this.isArchiving = true;
      const updates = {
        archived: true,
        archiveDate: this.getUTCNow().toDate(),
      };
      await this.workpackagesStore.updateWorkpackage({
        workpackageId,
        updates,
        omitStoreUpdate: true,
      });
      await Promise.all([
        this.workpackagesStore.fetchArchivedWorkpackages({
          limit: 5,
          offset: 0,
          filter: {},
          regexSearch: '',
          shouldGetTemplates: true,
        }),
      ]);
      // TODO vuetify
      // this.deleteWorkpackageTemplateById(this.workpackage._id);
      // if (this.entity === entities.template) {
      //   this.deleteWorkpackageTemplateById(this.workpackage._id);
      // } else {
      //   this.deleteWorkpackageById(this.workpackage._id);
      // }

      this.snackbarStore.showSuccess(i18n.t('notifications.archive'));
    },
    async onSelectProductsClick(workpackageId) {
      this.workpackageProductsStore.fetchWorkpackageProducts({ workpackageId });
    },
    async onSelectStoreClick(workpackageId) {
      await this.workpackagesStore.fetchSingleWorkpackage({
        includeStores: true,
        workpackageId,
      });
    },
  },
};
</script>
